import React from 'react';
import Layout from '../components/Layout';
import abi from '../assets/images/abi.png';
import eliezer from '../assets/images/eliezer.png';
import moto from '../assets/images/moto.png';
import luis from '../assets/images/luis.png';
import oscar from '../assets/images/oscar.jpg';

const IndexPage = () => (
  <Layout fullMenu>
    <article id="main">
      <header>
        <h2>Nuestro Equipo</h2>
        <p>Contamos con el mejor recurso humano del país.</p>
      </header>
      <section className="wrapper style5">
        <div className="inner">
          <div className="team-member">
            <img src={abi} alt="" />
            <h3>Abigail Gil</h3>
            <p>Ingeniero de sistemas informáticos</p>
          </div>
          <div className="team-member">
            <img src={eliezer} alt="" />
            <h3>Eliezer Ventura</h3>
            <p>Ingeniero de sistemas informáticos</p>
          </div>{' '}
          <div className="team-member">
            <img src={moto} alt="" />
            <h3>Moto Herrera</h3>
            <p>Ingeniero de sistemas informáticos</p>
          </div>{' '}
          <div className="team-member">
            <img src={oscar} alt="" />
            <h3>Oscar Cordero</h3>
            <p>Ingeniero de sistemas informáticos</p>
          </div>{' '}
          <div className="team-member">
            <img src={luis} alt="" />
            <h3>Luis Cerna</h3>
            <p>Ingeniero de sistemas informáticos</p>
          </div>
        </div>
      </section>
    </article>
  </Layout>
);

export default IndexPage;
